require('./calculateQuota.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { isEqual } = require('lodash/lang');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const MortgageRequestHeaderCalculateQuota = require('./mortgageRequestHeaderCalculateQuota/mortgageRequestHeaderCalculateQuota');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');

//@utilities
const { decimalsLength, getFormattedAmount } = require('utilities/currencyHelper');
const { getCollectiveByParams } = require('utilities/collectivesHelper');

//@constants
const { EURO_SYMBOL } = require('constants/index');
const { HABITUAL_HOUSING, SECOND_HOUSING, NEW_HOUSE, OLD_HOUSE,
    INITIAL_MAX_HOUSING_COST, STEP_COST_OF_HOUSING, MAX_NEED_MONEY, STEP_NEED_MONEY, MIN_TIME_MONEY_RETURN,
    MAX_TIME_MONEY_RETURN_HH, MAX_TIME_MONEY_RETURN_SH, STEP_TIME_MONEY_RETURN, PERCENTAGE_HABITUAL_HOUSING, MIN_NEED_MONEY, MIN_VALUE_COST_OF_HOUSING,
    PERCENTAGE_SECOND_HOUSING, FINAL_MAX_HOUSING_COST } = require('constants/mortgageRequestPreApproval').constantsCalculateCuota;
const { MORTGAGE_COLLECTIVE_PRODUCT_ALIAS } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;

class CalculateQuota extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeRange = this.handleChangeRange.bind(this);
        this.handleHouseCostChange = this.handleHouseCostChange.bind(this);
        this.handleNeedMoneyChange = this.handleNeedMoneyChange.bind(this);
    }

    componentDidMount() {
        const { formHandlers, immMortgageRequest } = this.props;
        const costOfhousing = immMortgageRequest.get('costOfhousing');
        costOfhousing && formHandlers.setMoneyNeedPercentage(costOfhousing, this.buildPercentageValueValid())
    }

    formatAmount = amount => getFormattedAmount({
        amount,
        decimalsLength: decimalsLength(amount)
    });

    buildHousingSelector() {
        const { formHandlers, immMortgageRequest } = this.props;
        const radioButtonTitle = formatText('calculateQuota-titleHousing');
        const firstRadioLabel = formatText('calculateQuota-housingFirstOption');
        const secondRadioLabel = formatText('calculateQuota-housingSecondOption');

        return (
            <div className="col-sm-12 calculate-quota__fields-container">
                <RadioButtonGroup
                    label={radioButtonTitle}
                    onChange={value => { formHandlers.handleInfoStepOne('useHousing', value) }}
                    name="calculate-quota-housing-selector"
                    idPrefix="calculate-quota-housing-selector"
                    selectedValue={immMortgageRequest.get('useHousing')}
                >
                    <RadioButton label={firstRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={HABITUAL_HOUSING} />
                    <RadioButton label={secondRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={SECOND_HOUSING} />
                </RadioButtonGroup>
            </div>
        );
    }

    buildTypeHousingSelector() {
        const { formHandlers, immMortgageRequest } = this.props;
        const radioButtonTitle = formatText('calculateQuota-titleTypeHousing');
        const firstRadioLabel = formatText('calculateQuota-typeHousingFirstOption');
        const secondRadioLabel = formatText('calculateQuota-typeHousingSecondOption');
        const typeHousing = immMortgageRequest.get('typeHousing');

        return (
            <div className="col-sm-12 calculate-quota__fields-container">
                <RadioButtonGroup
                    label={radioButtonTitle}
                    onChange={value => { formHandlers.handleInfoStepOne('typeHousing', value) }}
                    name="calculate-quota-type-housing-selector"
                    idPrefix="calculate-quota-type-housing-selector"
                    selectedValue={typeHousing}
                >
                    <RadioButton label={firstRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={NEW_HOUSE} />
                    <RadioButton label={secondRadioLabel} className="col-sm-6 calculate-quota__radio-container" value={OLD_HOUSE} />
                </RadioButtonGroup>
            </div>
        );
    }

    buildHomeUbication() {
        const { formHandlers, immMortgageRequest, communityList } = this.props;
        const errorMessage = formatText('mortgageRequestPreApproval-ubicationRequired');
        const errorState = isEqual(immMortgageRequest.get('whereHousing'), 0) && immMortgageRequest.get('whereHousingDirty');
        const communities = communityList.map(data => ({ label: data.name, value: data.id }));
        return (
            <div className="col-sm-11 calculate-quota__select-container" >
                <OKSelect
                    label="calculateQuota-titleHousingUbication"
                    name="home-ubication-select"
                    options={communities}
                    onChange={objectSelected => formHandlers.handleInfoStepOne('whereHousing', objectSelected.value)}
                    onBlur={() => { !immMortgageRequest.get('whereHousingDirty') ? formHandlers.handleDirtyWhereHousingField() : '' }}
                    value={immMortgageRequest.get('whereHousing')}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    searchable
                />
            </div>
        );
    }

    buildLeftContent() {
        const housingSelector = this.buildHousingSelector();
        const typeHousingSelector = this.buildTypeHousingSelector();
        const homeUbication = this.buildHomeUbication();

        return (
            <div className="col-sm-5">
                {housingSelector}
                {typeHousingSelector}
                {homeUbication}
            </div>
        );
    }

    buildPercentageValueValid() {
        const { immMortgageRequest } = this.props;
        return isEqual(immMortgageRequest.get('useHousing'), HABITUAL_HOUSING) ? PERCENTAGE_HABITUAL_HOUSING : PERCENTAGE_SECOND_HOUSING;
    }

    handleHouseCostChange(value, fromSlider) {
        const { formHandlers } = this.props;
        const fileUpdated = true;

        let increase = false;

        if (!fromSlider) {
            if (value <= INITIAL_MAX_HOUSING_COST) {
                increase = true;
            }

            this.handleChangeRange(increase, fileUpdated);
        }

        formHandlers.handleInfoStepOne('costOfhousing', value, this.buildPercentageValueValid());

    }

    handleChangeRange(increaseRange, fieldUpdated) {
        const { setMaxHousingCost, immMortgageRequest } = this.props;
        const costOfhousing = immMortgageRequest.get('costOfhousing');
        const maxHousingCost = increaseRange ? INITIAL_MAX_HOUSING_COST : FINAL_MAX_HOUSING_COST;
        const fromSlider = true;

        setMaxHousingCost(maxHousingCost, increaseRange);

        if (!fieldUpdated) {
            if (!increaseRange) {
                this.handleHouseCostChange(INITIAL_MAX_HOUSING_COST, fromSlider);
            } else {
                if (costOfhousing > INITIAL_MAX_HOUSING_COST) {
                    this.handleHouseCostChange(INITIAL_MAX_HOUSING_COST, fromSlider);
                }
            }
        }
    }

    handleNeedMoneyChange(value) {
        const { formHandlers } = this.props;
        formHandlers.handleSetNeedMoneyByUser();
        formHandlers.handleInfoStepOne('moneyNeed', value);
    }

    buildCostOfHousing() {
        const {
            immMortgageRequest,
        } = this.props;

        const amountMin = this.formatAmount(MIN_VALUE_COST_OF_HOUSING);
        const maxHousingCost = immMortgageRequest.get('maxHousingCost');
        const amountMax = this.formatAmount(maxHousingCost);
        const minLabel = `${formatText('contractLoanSliders-contractLoanSliders_min')} ${amountMin}`;
        let maxLabel = `${amountMax}`;
        if (maxHousingCost === FINAL_MAX_HOUSING_COST) {
            const maxLabelVisible = formatText('contractLoanSliders-contractLoanSliders_max');
            maxLabel = `${maxLabelVisible} ${amountMax}`;
        }
        const sliderLabel = formatText('calculateQuota-titleCostOfHousing');
        const costOfhousing = immMortgageRequest.get('costOfhousing');
        const hasErrorCost = costOfhousing != '' && immMortgageRequest.get('costOfhousingIsDirty') && !immMortgageRequest.get('costOfhousingIsValid');
        const hasErrorPercetage = immMortgageRequest.get('moneyNeedPercentageError');
        let errorMessage = formatText('calculateQuota-calculateQuota_costOfHousingError', [amountMin, this.formatAmount(FINAL_MAX_HOUSING_COST)]);
        if (hasErrorPercetage) {
            const minNeedMoney = this.formatAmount(MIN_NEED_MONEY);
            errorMessage = formatText('calculateQuota-calculateQuota_lessMoneyNeedPercentageError', [minNeedMoney]);
        }
        const tooltipComp = (
            <FormattedText className="calculate-quota__tooltip-content"
                value="calculateQuota-calculateQuota_costTooltip" />
        );
        const tooltip = (
            <OKTooltip
                content={tooltipComp}
                offset={[0, -15]}
                type="custom"
            />
        );
        const increaseRange = immMortgageRequest.get('increaseHousingCostRange');

        return (
            <div className="calculate-quota calculate-quota__sliders-container">
                <OKSliderInput
                    defaultValue={costOfhousing}
                    inputType="format"
                    max={maxHousingCost}
                    maxLabel={maxLabel}
                    min={MIN_VALUE_COST_OF_HOUSING}
                    minLabel={minLabel}
                    onChange={(value, fromSlider) => { this.handleHouseCostChange(value, fromSlider) }}
                    unit={EURO_SYMBOL}
                    step={STEP_COST_OF_HOUSING}
                    title={sliderLabel}
                    extraInfo={tooltip}
                    errorState={hasErrorCost || hasErrorPercetage}
                    errorMessage={errorMessage}
                    allowOutOfRangeValues
                    keepZeroAndEmpty
                    onChangeRage={this.handleChangeRange}
                    increaseRange={increaseRange}
                />
            </div>
        );
    }

    buildMoneyNeedInfo() {
        return (
            <FormattedText
                value="mortgageRequestPreApproval-descriptionMaxSelectedMoneyNeed"
                injectedStrings={[this.buildPercentageValueValid()]}
                className="calculate-quota calculate-quota__sliders-container-info"
            />
        )
    }

    buildMoneyNeed() {
        const {
            immMortgageRequest
        } = this.props;

        let maxNeedMoney = immMortgageRequest.get('moneyNeedPercentageValue');
        if ((immMortgageRequest.get('moneyNeedPercentageValue') >= MAX_NEED_MONEY) ||
            !immMortgageRequest.get('costOfhousing') ||
            (immMortgageRequest.get('costOfhousing') > FINAL_MAX_HOUSING_COST) ||
            (immMortgageRequest.get('costOfhousing') < MIN_VALUE_COST_OF_HOUSING)) {
            maxNeedMoney = MAX_NEED_MONEY
        }
        const amountMin = this.formatAmount(MIN_NEED_MONEY);
        const amountMax = this.formatAmount(maxNeedMoney);
        const amountMaxError = this.formatAmount(MAX_NEED_MONEY);
        const minLabel = `${formatText('contractLoanSliders-contractLoanSliders_min')} ${amountMin}`;
        const maxLabel = `${formatText('contractLoanSliders-contractLoanSliders_max')} ${amountMax}`;
        const sliderLabel = formatText('calculateQuota-titleHowMuchMoneyNeed');
        const tooltipComp = (
            <div className="calculate-quota">
                <div className="calculate-quota__container-title-tooltip">
                    <FormattedText value="calculateQuota-housingFirstOption" />
                </div>
                <div>
                    <FormattedText value="calculateQuota-descriptionHabitualHousing" />
                </div>
                <div className="calculate-quota__container-title-tooltip">
                    <FormattedText value="calculateQuota-housingSecondOption" />
                </div>
                <div>
                    <FormattedText value="calculateQuota-descriptionSecondHousing" />
                </div>
            </div>
        );
        const tooltip = (
            <OKTooltip
                content={tooltipComp}
                offset={[0, -15]}
                type="custom"
            />
        );
        const moneyNeed = immMortgageRequest.get('moneyNeed');
        const hasError = moneyNeed != '' && immMortgageRequest.get('moneyNeedIsDirty') && !immMortgageRequest.get('moneyNeedIsValid');
        const isPercentageError = immMortgageRequest.get('isPercentageError');

        let errorMessage = formatText('calculateQuota-calculateQuota_howMuchMoneyError', [amountMin, amountMaxError]);

        if (isPercentageError) {
            errorMessage = formatText('mortgageRequestPreApproval-descriptionMaxSelectedMoneyNeed', [this.buildPercentageValueValid()]);
        }
        return (
            <div className="calculate-quota calculate-quota__sliders-container">
                <OKSliderInput
                    defaultValue={moneyNeed}
                    inputType="format"
                    errorMessage={errorMessage}
                    errorState={hasError}
                    extraInfo={tooltip}
                    max={maxNeedMoney}
                    maxLabel={maxLabel}
                    min={MIN_NEED_MONEY}
                    minLabel={minLabel}
                    onChange={this.handleNeedMoneyChange}
                    unit={EURO_SYMBOL}
                    step={STEP_NEED_MONEY}
                    title={sliderLabel}
                    allowOutOfRangeValues
                    keepZeroAndEmpty
                />
                {!hasError && this.buildMoneyNeedInfo()}
            </div>
        );
    }

    buildTimeMoneyReturn() {
        const {
            formHandlers,
            immMortgageRequest
        } = this.props;

        const timeMoneyReturn = immMortgageRequest.get('timeMoneyReturn');
        const years = formatText('calculateQuota-years');
        const amountMax = isEqual(immMortgageRequest.get('useHousing'), HABITUAL_HOUSING) ? MAX_TIME_MONEY_RETURN_HH : MAX_TIME_MONEY_RETURN_SH;
        const step = STEP_TIME_MONEY_RETURN;
        const minLabel = `${formatText('contractLoanSliders-contractLoanSliders_min')} ${MIN_TIME_MONEY_RETURN}`;
        const maxLabel = `${formatText('contractLoanSliders-contractLoanSliders_max')} ${amountMax}`;
        const sliderLabel = formatText('calculateQuota-titleTimeMoneyReturn');
        const tooltipComp = (
            <div className="calculate-quota">
                <div className="calculate-quota__container-title-tooltip">
                    <FormattedText value="calculateQuota-housingFirstOption" />
                </div>
                <div className="calculate-quota__container-text-tooltip">
                    <FormattedText value="calculateQuota-descriptionReturnMoneyHabitualHousing" />
                </div>
                <div className="calculate-quota__container-title-tooltip">
                    <FormattedText value="calculateQuota-housingSecondOption" />
                </div>
                <div className="calculate-quota__container-text-tooltip">
                    <FormattedText value="calculateQuota-descriptionReturnMoneySecondHousing" />
                </div>
            </div>
        );
        const tooltip = (
            <OKTooltip
                content={tooltipComp}
                offset={[0, -15]}
                type="custom"
            />
        );
        const hasError = timeMoneyReturn !== '' && immMortgageRequest.get('timeMoneyReturnIsDirty') && !immMortgageRequest.get('timeMoneyReturnIsValid');
        const errorMessage = formatText('calculateQuota-calculateQuota_timeMoneyReturnError', [MIN_TIME_MONEY_RETURN, amountMax]);

        return (
            <div className="calculate-quota calculate-quota__sliders-container">
                <OKSliderInput
                    defaultValue={timeMoneyReturn}
                    extraInfo={tooltip}
                    max={amountMax}
                    maxLabel={maxLabel}
                    min={MIN_TIME_MONEY_RETURN}
                    minLabel={minLabel}
                    onChange={value => { formHandlers.handleInfoStepOne('timeMoneyReturn', value) }}
                    unit={years}
                    step={step}
                    title={sliderLabel}
                    allowOutOfRangeValues
                    errorState={hasError}
                    errorMessage={errorMessage}
                />
            </div>
        );
    }

    buildRightContent() {
        const costOfHousing = this.buildCostOfHousing();
        const moneyNeed = this.buildMoneyNeed();
        const timeMoneyReturn = this.buildTimeMoneyReturn();

        return (
            <div className="col-sm-7">
                {costOfHousing}
                {moneyNeed}
                {timeMoneyReturn}
            </div>
        );
    }

    buildCollectiveTag() {
        const { immGlobalVariables } = this.props;
        const defaultEuribor = immGlobalVariables.getIn(['variables', 'parameters', 'hipoteca', 'default_euribor']);
        const defaultTae = immGlobalVariables.getIn(['variables', 'parameters', 'hipoteca', 'default_tae_variable']);

        const taxes = {
            euribor: defaultEuribor,
            tae: defaultTae
        };

        const tooltipContent = <MortgagesCollectiveTagTooltip taxes={taxes} />;

        return (
            <CollectiveTag
                extraClass={"calculate-quota__collective-tag"}
                productAlias={MORTGAGE_COLLECTIVE_PRODUCT_ALIAS}
                tooltipContent={tooltipContent}
            />
        );
    }

    checkIsCollective() {
        const { immCollectives } = this.props;
        const immCollectivesInfo = immCollectives.get('collectivesInfo');
        return !!getCollectiveByParams(MORTGAGE_COLLECTIVE_PRODUCT_ALIAS, null, immCollectivesInfo);
    }

    render() {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const leftContent = this.buildLeftContent();
        const rightContent = this.buildRightContent();
        const collectiveTag = this.buildCollectiveTag();
        const isCollective = this.checkIsCollective();

        return (
            <div className="calculate-quota">
                <div className="calculate-quota__header-subtitle">
                    <h2 className="calculate-quota__header-subtitle--title">
                        <FormattedText
                            value="calculateQuota-headerTitle"
                            format="uppercase"
                        />
                        {collectiveTag}
                    </h2>
                    <h3 className="calculate-quota__header-subtitle--text">
                        <FormattedText
                            value="calculateQuota-calculateQuota_headerSubTitle"
                        />
                    </h3>
                </div>
                <div className="calculate-quota__header-benefits">
                    <MortgageRequestHeaderCalculateQuota
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        isCollective={isCollective}
                    />
                </div>
                <div className="calculate-quota__amortizations-notes">
                    <FormattedText value="calculateQuota-calculateQuota_totalAmortizationNotes" />
                </div>        
                <div className="calculate-quota__main-container">
                    <FormattedText className="calculate-quota__main-title" value="calculateQuota-title" />
                    <div className="calculate-quota__link-container">
                        <div className="col-sm-12 calculate-quota__form-container">
                            {leftContent}
                            {rightContent}
                            <div className="col-sm-12 calculate-quota__button-container">
                                <div className="calculate-quota__disclaimer">
                                    <FormattedText value="calculateQuota-firstDisclaimer" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CalculateQuota.propTypes = {
    communityList: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immMortgageRequest: PropTypes.object.isRequired,
    setMaxHousingCost: PropTypes.func.isRequired,
}

module.exports = CalculateQuota;
